export default __webpack_public_path__ + "static/media/2526 utensils top.9510ee8a.png";